import { Switch } from '@headlessui/react';
import cn from 'classnames';
import { twMerge } from 'tailwind-merge';

export type ToggleProps = {
  checked?: boolean;
  onToggle?: (checked: boolean) => void;
  disabled?: boolean;
  switchClassName?: string;
  buttonClassName?: string;
  containerClassName?: string;
};

export default function Toggle({ checked, onToggle, disabled, switchClassName: externalSwitchClassName, buttonClassName: externalButtonClassName, containerClassName }: ToggleProps) {
  const switchClassName = twMerge('relative inline-flex h-6.5 w-12.5 rounded-full hover:shadow ui-checked:bg-gradient-to-r ui-checked:from-[#BDFF00] ui-checked:to-[#05FF00] ui-not-checked:bg-disabled', externalSwitchClassName);
  const buttonClassName = twMerge(
    'absolute top-1/2 -translate-y-1/2 transition ease-in-out duration-250 inline-block w-4.5 h-4.5 transform bg-white rounded-full border border-line ui-not-checked:translate-x-1.5 ui-checked:translate-x-6.5',
    externalButtonClassName,
  );
    
  const swallowToggle = (e: React.MouseEvent) => {
    e.stopPropagation();
    onToggle?.(!checked);
  };

  return (
    <div
      className={containerClassName}
      onClick={swallowToggle}
    >
      <Switch
        disabled={disabled}
        checked={checked}        
        className={cn(
          switchClassName,          
        )}
        onClick={swallowToggle}
      >
        <span
          onClick={swallowToggle}
          className={cn(
            buttonClassName,          
          )}
        />        
      </Switch>
    </div>
  );
}
